export default {
  disabled: {
    opacity: '40%'
  },
};
